// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pk-users-matching .pk-users-matching-button-wrapper {
  width: 100%;
  padding: 20px calc(20% + 60px) 30px;
}
.pk-users-matching .pk-users-matching-button-wrapper .pk-save-user-matches {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/external-platform-integration/pk/pk-users-matching/pk-users-matching.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,mCAAA;AAAR;AACQ;EACI,WAAA;AACZ","sourcesContent":[".pk-users-matching {\r\n    .pk-users-matching-button-wrapper {\r\n        width: 100%;\r\n        padding: 20px calc(20% + 60px) 30px;\r\n        .pk-save-user-matches {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
